import { Outlet } from '@remix-run/react'

export default function layout() {
	return (
		<main>
			{/* <div className="text-center text-h2">Marathon Ranking</div> */}
			<Outlet />
		</main>
	)
}
